import { createApp } from 'vue'
import App from './App.vue'

import axios from 'axios'
import VueAxios from 'vue-axios'


import { createWebHistory, createRouter } from 'vue-router'

import HomeView from './views/HomeView.vue'
import AboutView from './views/AboutView.vue'
import TestView from './views/TestView.vue'
import SettingsView from './views/SettingsView.vue'
const routes = [
  { path: '/', component: HomeView },
  { path: '/systemSettings', component: SettingsView },
  { path: '/about', component: AboutView },
  { path: '/test', component: TestView }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})




// const app = createApp(App).mount('#app')
createApp(App)
.use(VueAxios, axios)
.use(router)
.mount('#app')

